import Const from 'const';
import {ItemStructureInterface} from 'src/components/organisms/range-of-outcomes/range-of-outcomes-by-positions/item-structure-interface';

class RangeOfOutcomesByPositions {
    private readonly data: object = {};
    constructor(items: ItemStructureInterface[] = []) {
        items.map((item) => {
            this.data[this.createKey(item.positions)] = item;
        });
    }
    getAllAsArr(): ItemStructureInterface[] {
        return cp(Object.values(this.data));
    }
    mergeItems(item: ItemStructureInterface): ItemStructureInterface[] {
        this.data[this.createKey(item.positions)] = cp(item);

        return this.getAllAsArr();
    }
    getRangeOfOutcomesPctByPositions(positions: string[]): number {
        const key = this.createKey(positions);

        if (key in this.data) {
            return this.data[key].value;
        }

        return Const.RANGES_OF_OUTCOMES_COMMON_DEFAULT_VALUE;
    }
    isDefaultValue(): boolean {
        const positionsMap = Const.MLB_POSITIONS_MAP;
        for (let position in positionsMap) {
            if (
                this.getRangeOfOutcomesPctByPositions(positionsMap[position]) !==
                Const.RANGES_OF_OUTCOMES_COMMON_DEFAULT_VALUE
            ) {
                return false;
            }
        }
        return true;
    }
    private createKey(positions: string[]): string {
        return positions.join('');
    }
}

const rangeOfOutcomesByPositions = new RangeOfOutcomesByPositions();

export default function (state = rangeOfOutcomesByPositions, action) {
    switch (action.type) {
        case Const.SET_RANGE_OF_OUTCOMES_BY_POSITIONS:
            return new RangeOfOutcomesByPositions(cp(action.data));

        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new RangeOfOutcomesByPositions();

        default:
            return state;
    }
}
